'use client';

import React from 'react';
import { ExperienceType } from '../types';
import WildPlanetStay from '@/components/stay-experience/WildPlanetStay';
import Hotels, { Hotel } from '@/components/packages/Hotels';
import { RoomOption } from '@/types/stayExperienceCardTypes';

interface ExperienceAccommodationOptionsProps {
  experience: unknown;
  type: ExperienceType;
}

export const ExperienceAccommodationOptions: React.FC<
  ExperienceAccommodationOptionsProps
> = ({ experience, type }) => {
  if (!experience) return null;

  // For packages, use hotels data
  if (type === 'package') {
    const exp = experience as {
      hotels?: Hotel[];
      accommodations?: Hotel[];
    };

    const hotels = exp?.hotels || exp?.accommodations || [];

    if (!Array.isArray(hotels) || hotels.length === 0) return null;

    return <Hotels hotel={hotels} />;
  }

  // For stays, use roomOptions
  const exp = experience as {
    roomOptions?: RoomOption[];
  };

  const roomOptions = exp?.roomOptions || [];

  if (!Array.isArray(roomOptions) || roomOptions.length === 0) return null;

  return <WildPlanetStay stay={roomOptions} />;
};
